import React from 'react';
import MatchRequests from '../components/Matches/MatchRequests';
import { Container } from '@mui/material';

const MatchRequestsPage: React.FC = () => (
  <Container maxWidth="md" sx={{ mt: 3 }}>
    <MatchRequests />
  </Container>
);

export default MatchRequestsPage; 